import {Col, Row} from 'react-bootstrap';
import { PageHeader } from '../components/PageHeader';
import {fetchDashboardStats} from "../api/dashboardApi";
import {useQuery} from "@tanstack/react-query";
import {DashboardCard} from "../components/DashboardCard";
import {fetchAuthStatus} from "../api/authApi";

export function DashboardPage() {
    const { data: authData } = useQuery({
        queryKey: ['auth-status'],
        queryFn: fetchAuthStatus,
    });

    const canSeeStats = authData?.user?.permissions?.includes('dashboard.can_see_dashboard_stats');

    const { data, isLoading, isError, error } = useQuery({
        queryKey: ['dashboard-stats'],
        queryFn: fetchDashboardStats,
        enabled: !!canSeeStats,
    });
    return (
    <div className="page-container">
      <PageHeader title="Dashboard" />
      {canSeeStats ? (
          <Row className="g-3">
              <Col md={6} xl={4}>
                  <DashboardCard title="Deliveries with missing documents"
                                 description="Outgoing transfers missing customs documents or serial numbers."
                                 link="/dashboard/deliveries?type=outgoing"
                                 isLoading={isLoading}
                                 value={data?.invalid_deliveries_count_outgoing}/>
              </Col>
              <Col md={6} xl={4}>
                  <DashboardCard title="Receipts with missing documents"
                                 description="Incoming transfers waiting on documentation cleanup."
                                 link="/dashboard/deliveries?type=incoming"
                                 isLoading={isLoading}
                                 value={data?.invalid_deliveries_count_incoming}/>
              </Col>
              <Col md={6} xl={4}>
                  <DashboardCard title="Internal transfers with missing documents"
                                 description="Warehouse movements with incomplete compliance data."
                                 link="/dashboard/deliveries?type=internal"
                                 isLoading={isLoading}
                                 value={data?.invalid_deliveries_count_internal}/>
              </Col>
              <Col md={6} xl={4}>
                  <DashboardCard title="Purchases not fully billed"
                                 description="Purchase orders with invoice coverage below 100%."
                                 link="/dashboard/purchases"
                                 isLoading={isLoading}
                                 value={data?.unbilled_purchases}/>
              </Col>
              <Col md={6} xl={4}>
                  <DashboardCard title="Vendor bills with issues"
                                 description="Bills with empty references or waiting placeholders."
                                 link="/dashboard/vendor-bills"
                                 isLoading={isLoading}
                                 value={data?.invalid_vendor_bills}/>
              </Col>
          </Row>
      ) : (
          <div className="text-center py-5">
              <p className="text-muted">Select an action from menu.</p>
          </div>
      )}
    </div>
  );
}
